export default __webpack_public_path__ + "static/media/2.4ff2a976.svg";